import useScrollReveal from '../hooks/useScrollReveal';

export default function RuleCard({ number, title, body, color, delay = 0 }) {
  const [ref, visible] = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`rule-card reveal ${visible ? 'visible' : ''}`}
      style={{
        transitionDelay: visible ? `${delay}ms` : '0ms',
        borderColor: `${color}40`,
      }}
    >
      <div
        className="rule-badge"
        style={{ background: `${color}22`, color }}
      >
        {String(number).padStart(2, '0')}
      </div>
      <div className="rule-title">{title}</div>
      <div className="rule-body">{body}</div>
    </div>
  );
}
